// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Despesas_VincularPlanoContasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /despesas/{id}/vincular_plano_contas
 *
 * Links a despesa to a plano de contas (budget account).
 * Returns the despesa_id, plano_conta_id, and vinculado status.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Despesas_VincularPlanoContasResponseDados {
despesa_id?: number
plano_conta_id?: number
vinculado?: boolean
}

export type Despesas_VincularPlanoContasResponse = ApiResponse<Despesas_VincularPlanoContasResponseDados>;

registerResponseContract('Despesas_VincularPlanoContasResponse', {
  despesa_id:     { type: 'number',  required: false },
  plano_conta_id: { type: 'number',  required: false },
  vinculado:      { type: 'boolean', required: false },
})
